<div class="share-link-container">
  <header class="share-link-header">
    <span class="share-link-header__icon">
      <svg-icon
        src="assets/icons/share.svg"
        [svgStyle]="{
          'width.px': 20,
          'height.px': 10
        }"
      ></svg-icon>
    </span>
    <h1 class="share-link-header__title">{{ title | translate }}</h1>
  </header>

  <main class="share-link-wrapper">
    <div class="share-link-wrapper__inputWrapper">
      <input type="text" [value]="linkToCopy()" #inputLink readonly />
      <commons-button
        [outline]="true"
        [rounded]="true"
        [buttonText]="'buttons.copy_link' | translate"
        (buttonClick)="handleCopyLink(inputLink.value)"
      ></commons-button>
    </div>
  </main>

  <footer class="share-link-footer">
    <p>{{ 'shared.expiration_date' | translate }}</p>
    <commons-button
      [rounded]="true"
      [buttonText]="'buttons.concluded' | translate"
      (buttonClick)="onClose()"
    ></commons-button>
  </footer>
</div>
